import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import * as React from 'react';
import { RootZone } from './RootZone';
import { LoadingMode, useViewState } from './useViewState';
export { isContainerUseViewStateProps as isContainerViewLoaderProps, isSpecificViewRIDUseViewStateProps as isSpecificViewRIDLoaderProps } from './useViewState';
export function ViewLoader(props) {
  var piletApi = props.piletApi,
    fallbackView = props.fallbackView,
    loadingMode = props.loadingMode,
    viewContext = props.viewContext,
    contractData = props.contractData;
  var contractDataWithFallback = contractData !== null && contractData !== void 0 ? contractData : viewContext;
  var _useViewState = useViewState(props),
    status = _useViewState.status,
    views = _useViewState.views;
  if ([LoadingMode.FallbackOnly, LoadingMode.FallbackButLoadInBackground].includes(loadingMode)) {
    return /*#__PURE__*/React.createElement(RootZone, {
      piletApi: piletApi,
      allViews: [fallbackView],
      contractData: contractDataWithFallback
    });
  }
  if (status === 'not-requested' || status === 'loading') {
    var _props$loader;
    return /*#__PURE__*/React.createElement(React.Fragment, null, (_props$loader = props.loader) !== null && _props$loader !== void 0 ? _props$loader : null);
  }
  return /*#__PURE__*/React.createElement(RootZone, {
    piletApi: piletApi,
    allViews: views ? [].concat(_toConsumableArray(views), [fallbackView]) : [fallbackView],
    startingViewRID: views && isContainerViewLoaderProps(props) ? props.startingViewRID : undefined,
    contractData: contractDataWithFallback
  });
}
function isContainerViewLoaderProps(props) {
  return props.hasOwnProperty('containerRID') && !props.hasOwnProperty('viewId');
}